export default __webpack_public_path__ + "static/media/test_icon.22e900a4.svg";